module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0046.jpg?v=5023a21d";